<section class="featured-services-area pb-2 pt-3">
    <div class="container">

        <div class="section-title text-center mb-5">
            <div class="h6 text-uppercase"><b>Tam Servis</b></div>
            <div class="h2"><span>Shopify Mağazanız için Her Şey Bir Arada</span></div>
        </div>

        <div class="row">
            <div class="col-lg-5 col-md-6 col-sm-6">
                <div class="bg-white text-center border rounded shadow-sm p-4">
                    <img src="../../../../../assets/img/s_all2.webp" alt="entegrasyon" width="500" height="456"
                        class="rounded">
                </div>
            </div>

            <div class="col-lg-7 col-md-6 col-sm-6 pt-4">
                <div class="px-lg-5 px-md-4">
                    <div class="h4 mb-4">Kurulum, Tasarım, Global Bağlantılar: Hepsi Tek Çatıda</div>
                    <p>Shopify mağazanız için sadece kurulum, tasarım ve ayarlarla kalmıyoruz. Entegre aracımız
                        sayesinde, mağazanızı pazaryerleri, kargo ve muhasebe yazılımları ile bağlıyoruz.
                        Böylece üçüncü parti eklentilerle uğraşmaz, teknik ayrıntılarda zaman kaybetmezsiniz.
                    </p>
                    <p>Tüm bu süreçlerde teknik desteği biz sağlıyoruz, böylece mağazanız sorunsuz bir şekilde çalışır
                        ve sadece işinize odaklanabilirsiniz.
                        Biz, Shopify mağazanız için tam anlamıyla tek çözüm ortağınız olmayı hedefliyoruz.</p>
                    <p>Yeni platformunuza hızlıca geçiş yapın ve Shopify’ın sunduğu güçlü entegrasyon ve otomasyon
                        özelliklerinden faydalanın.</p>

                    <div class="py-4 d-flex">
                        <a [routerLink]="'/iletisim'" class="btn btn-dark me-3">
                            <svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" viewBox="0 0 48 48">
                                <rect width="48" height="48" fill="none" />
                                <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                    d="M19.308 12.467a24 24 0 0 1-.881-4.384C18.27 6.602 16.977 5.5 15.488 5.5H8.58c-1.777 0-3.145 1.535-2.989 3.304c1.575 17.829 15.777 32.03 33.606 33.606c1.77.156 3.304-1.207 3.304-2.984v-6.16c0-2.248-1.102-3.536-2.583-3.693a24 24 0 0 1-4.384-.88a4.9 4.9 0 0 0-4.87 1.243l-2.957 2.957a31.27 31.27 0 0 1-12.599-12.599l2.957-2.957a4.9 4.9 0 0 0 1.244-4.87m4.053 24.77l4.344-4.344m-16.943-8.255l4.344-4.344"
                                    stroke-width="1" />
                            </svg>
                            Detaylı Bilgi Alın</a>
                        <a href="https://calendly.com/dotcrea/" target="_blank" class="btn btn-success">
                            <svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" viewBox="0 0 48 48">
                                <rect width="48" height="48" fill="none" />
                                <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                    d="M41.05 12.6c1.63-1.3 2.85-.23 2.85 1.14v20.52c0 1.73-1.22 2.44-2.85 1.14L26.79 24ZM14 8v32M4.9 17.16h21.89v13.68H4.9m0-13.68L14 8h18.5a3.2 3.2 0 0 1 2.85 2.85v26.26A3.2 3.2 0 0 1 32.5 40H7.75a2.81 2.81 0 0 1-2.85-2.89Z"
                                    stroke-width="1" />
                            </svg>
                            Meet Planlayın</a>
                    </div>

                </div>
            </div>
        </div>
    </div>
</section>